import React from "react";

const ManualLaboratoryResult = () => {
  return <div>ManualResult</div>;
};

export default ManualLaboratoryResult;
